module.exports = __webpack_public_path__ + "0c480fbdf407bd403775fe2c99d8b8cf.MP3";